export function flattenAgenda(events) {
    const map = {}
    const walk = (e, parentId) => {
        if (!e) return
        map[String(e.id)] = { ...e, parentId }
        for (const c of e.children ?? []) walk(c, String(e.id))
    }
    for (const e of Array.isArray(events) ? events : []) walk(e, null)
    return map
}

export function extractEventIds(text) {
    const ids = []
    const seen = new Set()
    for (const m of text.matchAll(/\(#(\d+)\)/g)) {
        if (!seen.has(m[1])) {
            seen.add(m[1])
            ids.push(m[1])
        }
    }
    return ids
}

export function eventToSession(event) {
    const tz = event.venue?.timezone ?? "America/New_York"
    const date = new Date(event.datetime_start)
    const dayName = date.toLocaleDateString("en-US", { weekday: "short", timeZone: tz })
    const time = date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        timeZone: tz,
    })
    const parts = [`${dayName} ${time}  ·  ${event.venue?.name}`]
    if (event.depth >= 2) {
        const speakers = (event.moderators ?? [])
            .flatMap(g => g.users ?? [])
            .map(u => u.full_name)
            .filter(Boolean)
        if (speakers.length) parts.push(speakers.join(", "))
    }
    return {
        id: event.id,
        title: event.title,
        meta: parts.join("  ·  "),
        time: `${dayName} ${time}`,
        location: event.venue?.name || null,
        meta2: event.depth >= 2 ? event.breadcrumb : null,
        saved: false,
        calAdded: false,
    }
}
